import { PlusIcon } from '@phosphor-icons/react';

import { Breadcrumb } from 'components/Breadcrumb';
import { LinkButton } from 'components/button/ButtonLink';
import { PageHeading } from 'components/PageHeading';
import { ITabItem, TabBar } from 'components/tabs/Tabs';

export const TRAILERS_OVERVIEW_PATH = '/internal/trailers/overview';
export const TRAILERS_LIST_PATH = '/internal/trailers/list';
export const TRAILERS_MAP_PATH = '/internal/trailers/map';

const TAB_ITEMS: ITabItem[] = [
  { title: 'Overzicht', path: TRAILERS_OVERVIEW_PATH },
  { title: 'Trailers', path: TRAILERS_LIST_PATH },
  { title: 'Kaart', path: TRAILERS_MAP_PATH },
];

/**
 * Heading + tab strip shared by the trailer fleet tabs. Rendered by each tab
 * page instead of by a layout route, so the list tab keeps its full-height
 * `ListPage` body.
 */
export const TrailersHeading = () => {
  return (
    <>
      <PageHeading
        noMarginBottom
        leftSide={<Breadcrumb currentItem="Trailers" />}
        rightSide={
          <LinkButton to="/internal/trailers/new" color="primary" iconLeft={<PlusIcon className="button-icon" />}>
            Nieuwe trailer
          </LinkButton>
        }
      />

      <div className="shrink-0 bg-surface px-6">
        <TabBar items={TAB_ITEMS} />
      </div>
    </>
  );
};
